export default {
  "meta": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NARS"])},
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])}
  },
  "hero": {
    "loader": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("progress")), "%"])},
    "scroller": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scroll to Explore"])}
  },
  "stack": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A simple childhood in tarbes."])},
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["France is renowned for its rich cultural heritage and sense of aesthetics, and growing up in a small town in France has shaped François' artistic sensibility and authenticity."])}
  },
  "next": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next Chapter"])},
    "continue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tap to continue"])}
  },
  "products": {
    "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View product page"])}
  },
  "carousel": {
    "slide": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slide to view"])},
    "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EN VOIR PLUS"])},
    "learn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EN SAVOIR PLUS"])}
  },
  "text": {
    "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View more"])}
  },
  "chapter-1": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["IL ÉTAIT UNE FOIS. NARS."])},
    "slice-0": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-0_image.png"])}
      }
    },
    "slice-1": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["30 ANS DE BEAUTÉ AUDACIEUSE"])},
      "youtube": {
        "desktop": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2uKUUR6ZDqM"])},
        "mobile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["W5SCFeqkyxg"])}
      },
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-1_image.jpg"])}
      }
    },
    "slice-2": {
      "text": {
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dans les années 1990, François Nars révolutionne l’univers du maquillage—dans les coulisses, sur les podiums, et dans les publicités. Aujourd’hui, son approche avant-gardiste de la beauté continue d’encourager la créativité, l’expression personnelle et le talent artistique inépuisable."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“ J’adore puiser mon inspiration dans le passé, cela m’aide à me projeter dans l’avenir. Saluons 30 ans de création et encore de nombreuses années de beauté audacieuse à venir.”"])},
        "author": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["— François Nars, fondateur et directeur artistique"])}
      },
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-2_image-1.jpg"])}
      }
    },
    "slice-3": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ICÔNE UN JOUR. ICÔNE TOUJOURS."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tout a commencé en 1994 avec 12 rouge à lèvres. 30 ans plus tard, NARS célèbre cet anniversaire marquant en mettant à l’honneur les produits iconiques qui apportent caractère et personnalité sans limites à votre routine."])},
      "item-1": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blush"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le blush culte."])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le blush incontournable depuis près de trente ans. Avec le lancement d’Orgasm en 1999, François Nars a instauré le rouge aux joues comme expression d’un sentiment. Notre produit iconique—à présent disponible dans une formule repensée—vous permet d’exprimer votre humeur et vos émotions grâce à une gamme complète de blushes désirables. Un éclat sublime à tout moment."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Le blush ne connaît pas de limites. Soyez audacieuse” — François Nars, Fondateur et Directeur artistique"])},
        "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.be/fr/blush/999NAC0000192.html"])},
        "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EN SAVOIR PLUS"])},
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-3_image-1.jpg"])}
        }
      },
      "item-2": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Radiant Creamy Concealer"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un must-have du quotidien facile à utiliser."])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conçu selon les techniques approuvées par notre artiste fondateur, cet anti-cernes incontournable est le chouchou des podiums depuis son lancement . Illuminez, corrigez, sublimez et célébrez notre héritage tout en incluant le vôtre."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Camoufler sans masquer permet d’obtenir une peau plus lumineuse et éclatante de santé.” — François Nars, Fondateur et Directeur artistique"])},
        "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.be/fr/radiant-creamy-concealer/999NACRCC0001.html"])},
        "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EN SAVOIR PLUS"])},
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-3_image-2.jpg"])}
        }
      },
      "item-3": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Light reflecting<sup>TM</sup> Foundation"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formule soin."])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Notre formule primée incarne parfaitement la philosophie de François Nars d’une peau naturellement lumineuse, éclairée de l’intérieur. Ce fond de teint-soin floute instantanément les imperfections tout en améliorant la clarté du teint au fil du temps. Comme le dit François, une belle peau constitue la base d’un beau maquillage."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“The best skin is skin that can reflect light.” — François Nars, Fondateur et Directeur artistique"])},
        "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.be/fr/explicit-lipstick/999NAC0000221.html"])},
        "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EN SAVOIR PLUS"])},
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-3_image-3.jpg"])}
        }
      },
      "item-4": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Light Reflecting<sup>TM</sup> Setting Powder"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fini lumineux photogénique."])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un classique culte pour une peau Light Reflecting™. Visionnaire dans l’univers du maquillage artistique et de la photographie, François Nars utilise la lumière comme un instrument pour sublimer le teint dans la vie, comme devant la caméra. Célébrons 30 années de plus de peau lumineuse, comme éclairée de l’intérieur."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“La peau doit rayonner comme jamais.” — François Nars, Fondateur et Directeur artistique"])},
        "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.be/fr/poudre-compacte-fixante-light-reflecting/999NAC0000099.html"])},
        "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EN SAVOIR PLUS"])},
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-3_image-4.jpg"])}
        }
      },
      "item-5": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Explicit Lipstick"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La couleur qui a une longueur d’avance."])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une couleur à la pointe indéniable—et rechargeable— depuis trente ans. Un nouveau raisin haute précision glisse facilement pour des lèvres sculptées avec sophistication en une seule application. Inspiré par la formule par laquelle tout a commencé, optimisé pour la génération actuelle."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Pour moi, le rouge à lèvres a toujours représenté la confiance en soi. Saluons trente ans de couleurs qui ont permis de révéler des personnalités, et célébrons le contenu Explicit à venir.” — François Nars, Fondateur et Directeur artistique"])},
        "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.be/fr/explicit-lipstick/999NAC0000221.html"])},
        "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EN SAVOIR PLUS"])},
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-3_image-5.jpg"])}
        }
      }
    },
    "slice-4": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PUISSANCE VISUELLE"])},
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Depuis 1996, François Nars a signé de nombreuses campagnes de la marque et imprimé de son style emblématique caractérisé par son imagination audacieuse, sa personnalité et son intuition. Créateur d’images visionnaire, il a compris le pouvoir de l’image depuis longtemps—son travail nous a aidé à repousser les limites des standards de beauté traditionnels."])},
      "item-1": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TEINT"])},
        "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faisant partie de l’une des premières campagnes de l’histoire de la marque, cette image de 1997 se démarquait nettement des publicités beauté de l’époque, et est aujourd’hui toujours aussi moderne et intemporelle. Alors qu’à première vue, l’image paraît centrée sur les lèvres audacieuses, elle l’est plutôt sur la peau naturelle et lumineuse."])},
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-4_image-1.jpg"])},
          "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Complexion"])}
        }
      },
      "item-2": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ORGASM"])},
        "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rien n’incarne mieux NARS que la campagne Printemps/Été 1999 pour le lancement d’Orgasm. La teinte à transformation offre un jeu infini purement basé sur la zone d’application, légèrement estompée de chaque côté du nez. Une technique utilisée par François en 1999 et qui est devenue une tendance maquillage virale."])},
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-4_image-2.jpg"])},
          "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Orgasm"])}
        }
      },
      "item-3": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["LAGUNA"])},
        "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Photographiée à Motu Tane en Polynésie française, la campagne Automne/Hiver 2003 met en lumière la Laguna Bronzing Powder iconique. L’intensité de la lèvre rouge par rapport au visage nu est équilibré par la chaleur de la poudre bronzante —une part subtile mais essentielle du look."])},
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-4_image-3.jpg"])},
          "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Laguna"])}
        }
      }
    },
    "next": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_next.jpg"])}
      },
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["François Nars"])}
    }
  },
  "chapter-2": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["François Nars"])},
    "slice-1": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["INSPIRÉ PAR SON ÉDUCATION"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Né et élevé dans le Sud de la France, François Nars a passé son enfance plongé dans les magazines Vogue de sa mère et dans les classiques du cinéma hollywoodien et européen. Guidé par sa passion pour la beauté et le style, il suit les cours de l’École de maquillage Carita à Paris."])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-1_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-1_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-1_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-1_image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-1_image-5.jpg"])}
      }
    },
    "slice-2": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SES PREMIÈRES ET ÉTERNELLES MUSES"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-2_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-2_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-2_image-3.jpg"])}
      }
    },
    "slice-3": {
      "text": {
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Les toutes premières inspirations créatives de François—et les plus durables, ont été les femmes de sa vie. Sa mère, Claudette, et ses grands-mères ont été des exemples audacieux de muses et de mentors, démontrant une force de caractère indéfectible et le pouvoir libérateur du style personnel."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Mes icônes de beauté sont ma mère, mes grands-mères, Garbo et Dietrich.”"])},
        "author": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["— François Nars, Founder & Creative Director"])}
      },
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-3_image-1.jpg"])}
      }
    },
    "slice-4": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DES ACTIVITÉS ÉDITORIALES"])},
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Encouragé par Polly Mellen, à l’époque rédactrice en chef du <em>Vogue</em> américain, François s’installe à New York en 1984 où il intègre la rédaction. Sa carrière explose alors qu’il façonne de nouveaux standards de la beauté pour les pages de <em>Vogue</em>, <em>ELLE</em>, <em>Harper’s Bazaar</em>, et autres."])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-5.jpg"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-6.jpg"])}
      }
    },
    "slice-5": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["STAR DES PODIUMS. <br/> SUCCÈS SUR LES PODIUMS."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mettant ses talents au service des podiums, François collabore avec des créateurs comme Karl Lagerfeld et Marc Jacobs. En 1994, il lance une ligne de 12 rouges à lèvre chez Barneys New York afin d’assouvir ses propres désirs artistiques. Le succès est immédiat, c’est la naissance de NARS Cosmetics."])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-5_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-5_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-5_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-5_image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-5_image-5.jpg"])}
      }
    },
    "next": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_next.jpg"])}
      },
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L’APPROCHE DU <br/>MAQUILLAGE DE NARS"])}
    }
  },
  "chapter-3": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L’APPROCHE DU <br/>MAQUILLAGE DE NARS"])},
    "slice-1": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["LES DÉBUTS DE LA MARQUE"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Emblématique. Individuel. Inattendu—NARS. Nés de la fascination de François pour la couleur et la texture, ses 12 rouges à lèvres originaux ont inspiré une ligne cosmétique complète conçue pour que les femmes succombent à sa vision de la beauté. Trente ans et d’innombrables produits plus tard, NARS inspire toujours."])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-1_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-1_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-1_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-1_image-4.jpg"])}
      }
    },
    "slice-2": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["UNE BEAUTÉ SANS RÈGLES"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un teint radieux. Un œil charbonneux séducteur. Des lèvres audacieuses. Le look NARS iconique ne cesse d’évoluer et n’est jamais ennuyeux."])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-5.jpg"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-6.jpg"])}
      },
      "image-7": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-7.jpg"])}
      },
      "image-8": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-8.jpg"])}
      },
      "image-9": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-9.jpg"])}
      },
      "image-10": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-10.jpg"])}
      }
    },
    "slice-3": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["THE MULTIPLE"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspiré par une séance photo pour Harper’s Bazaar en 1996, The Multiple est un incontournable beauté depuis sa création. Utilisant une seule couleur de rouge à lèvres pour les lèvres, les joues et les yeux, François a créé un look monochromatique spectaculaire sur le top modèle Carolyn Murphy, lançant une tendance du maquillage sans effort."])},
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-3_image-1.jpg"])}
      }
    },
    "slice-4": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["LE VISAGE AVANT TOUT"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Des face charts détaillés à ses principales philosophies beauté, François est tout autant enthousiaste à communiquer sa vision qu’à la créer."])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-4_image-1.jpg"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["COULEUR MONOCHROMATIQUE"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Notre vision du maquillage monochromatique viral, avec une touche de couleur sur les joues et sur le nez, les lèvres parées d'une pointe de rose, et les yeux étincelants dans des tons rose."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Avec une couleur subtil ou intense, vous ne pouvez pas vous tromper.”"])},
        "author": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["— François Nars, Fondateur et Directeur artistique"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-4_image-2.jpg"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["LE POUVOIR DES TONS NEUTRES"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Les tons neutres n’ont jamais paru aussi audacieux, avec le blush appliqué en forme de boomerang le long de la joue, les yeux ornés de tons cuivrés et un rouge à lèvres nude inspiré des années 90."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Les tons neutres permettent au monde de voir votre vrai visage et votre vraie personnalité et ainsi, de rehausser votre beauté naturelle.”"])},
        "author": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["— François Nars, Fondateur et Directeur artistique"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-4_image-3.jpg"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DES LÈVRES INTENSES"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un rouge à lèvres mat audacieux classique et élégant, équilibré ici par un regard défini signé NARS avec un léger effet charbonneux et des joues sculptées dans des tons chauds."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“A strong lip always adds power to your look.”"])},
        "author": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["— François Nars, Fondateur et Directeur artistique"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-4_image-4.jpg"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ILLUMINER TOUT EN LÉGÈRETÉ"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un rouge à lèvres doux assorti à un regard légèrement défini, inspiré des années 60, crée un look éthéré, tandis que les tons chauds et froids associés sur les joues apportent un éclat seconde peau superbe."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Les lèvres sont douces mais intenses—un look totalement puissant.”"])},
        "author": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["— François Nars, Fondateur et Directeur artistique"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-4_image-5.jpg"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMOKEY SHOW"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un regard prune intense avec des lèvres ultra-brillantes crée une version tendance et sophistiquée de l’effet charbonneux classique avec une touche d’éclat."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Le maquillage des yeux est le domaine cosmétique permettant la plus grande créativité. La clé est l’estompage.”"])},
        "author": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["— François Nars, Fondateur et Directeur artistique"])}
      }
    },
    "next": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_next.jpg"])}
      },
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["UNE CARRIÈRE PROLIFIQUE"])}
    }
  },
  "chapter-4": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["UNE CARRIÈRE <br/>PROLIFIQUE"])},
    "slice-1": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<strong>François</strong> <strong>NARS: </strong><br/>\n<strong>ARCHIVES</strong>"])},
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créateur d’image visionnaire, François a constitué un catalogue étendu d’œuvres photographiques au fil des ans, culminant avec un documentaire sur sa vie et ses réalisations."])}
    },
    "slice-2": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DÉCOUVREZ LA COLLECTION"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["X-RAY (1999)"])},
        "caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<em>X-RAY</em> (1999)"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NARS 15x15 (2009)"])},
        "caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<em> NARS 15x15</em> (2009)"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND: EXPRESS YOURSELF - 2013"])},
        "caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<em>MAKEUP YOUR MIND:<br/>\nEXPRESS YOURSELF</em> (2013)"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["faery lands (2013)"])},
        "caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<em>faery lands</em> (2013)"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-5.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FRANÇOIS NARS (2016)"])},
        "caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<em>FRANÇOIS NARS</em> (2016)"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-6.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PERSONA (2021)"])},
        "caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<em>PERSONA</em> (2021)"])}
      }
    },
    "slice-3": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["X-RAY"])},
      "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["1999"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une collection de portraits élégants et stylisés de ceux dont le style incomparable a inspiré François, notamment Diane von Furstenberg, Carine Roitfeld, Boy George, et bien d’autres encore."])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EN VOIR PLUS"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GRACE JONES"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DIANE VON FURSTENBERG"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["CHRISTY TURLINGTON"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EARTHA KITT"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-5.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Carine Roitfeld"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-6.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Boy George"])}
      },
      "image-7": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-7.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Liza Minnelli"])}
      },
      "image-8": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-8.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manolo Blahnik"])}
      }
    },
    "slice-4": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NARS 15X15"])},
      "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2009"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un ouvrage de portraits de célébrités en édition limitée inspirés par les noms de teintes emblématiques de NARS en l’honneur du 15ème anniversaire de NARS Cosmetics."])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EN VOIR PLUS"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-4_image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MARC JACOBS"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-4_image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NAOMI CAMPBELL"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-4_image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AMBER VALLETA"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-4_image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DAYLE HADDON"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-4_image-5.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["daphne guinness"])}
      }
    },
    "slice-5": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND: EXPRESS YOURSELF"])},
      "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2013"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un manuel beauté proposant des techniques de maquillage sophistiquées, des instructions précises et des portraits saisissants « avant » et « après »."])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.com/USA/makeup-your-mind%3A-express-yourself/0607845032045.html"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EN VOIR PLUS"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND (2013)"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND (2013)"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND (2013)"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND (2013)"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-5.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND (2013)"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-6.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND (2013)"])}
      }
    },
    "slice-6": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands"])},
      "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2013"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une collection de photographies fascinantes de Motu Tane, une île privée de Polynésie française dont les paysages, les habitants et la culture offrent à François une source d’inspiration infinie."])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EN VOIR PLUS"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 1"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 2"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 3"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 4"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-5.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 5"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-6.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 6"])}
      },
      "image-7": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-7.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 7"])}
      },
      "image-8": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-8.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 8"])}
      },
      "image-9": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-9.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 9"])}
      },
      "image-10": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-10.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 10"])}
      },
      "image-11": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-11.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 11"])}
      }
    },
    "slice-7": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois NARS"])},
      "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2016"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une photo-biographie captivante qui conte l’histoire fascinante de François Nars, sa vision révolutionnaire et son univers de beauté rare."])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EN VOIR PLUS"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-7_image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-7_image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-7_image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-7_image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      }
    },
    "slice-8": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PERSONA"])},
      "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2021"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un ouvrage, en édition limitée, de portraits éclectiques de personnalités créatives de tous âges signés François Nars."])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.com/USA/persona-book/0194251071077.html"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EN VOIR PLUS"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-8_image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-8_image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-8_image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-8_image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      }
    },
    "slice-9": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<strong>Unknown Beauty: <br/>François Nars</strong>"])},
      "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["RÉALISÉ PAR LISA IMMORDINO VREELAND"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 1"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 2"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 3"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 4"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-5.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 5"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-6.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 6"])}
      },
      "image-7": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-7.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 7"])}
      },
      "image-8": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-8.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 8"])}
      },
      "image-9": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-9.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 9"])}
      },
      "image-10": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-10.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 10"])}
      }
    },
    "slice-10": {
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un long-métrage documentaire qui offre une incursion rare dans la vie du Fondateur et Directeur artistique, François Nars, et nous plonge dans les inspirations qui ne cessent de nourrir sa créativité depuis l’enfance."])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.amazon.com/Beauty-Fran%C3%A7ois-Nars-Charlotte-Rampling/dp/B0C9VQMC8S"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["REGARDER"])}
    },
    "next": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_next_image.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["LES ICÔNES NARS"])}
      },
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["LES ICÔNES NARS"])}
    }
  },
  "chapter-5": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["LES ICÔNES NARS"])},
    "slice-0": {
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Découvrez les icônes NARS qui libère l’artiste qui est en vous, toutes conçues pour apporter caractère et personnalité sans limites à votre routine. Toujours repousser les limites."])}
    },
    "slice-1": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["LIGHT REFLECTING<sup>TM</sup> SETTING POWDER"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un classique culte instantané de NARS pour une peau Light Reflecting<sup>TM</sup> lumineuse."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La formule ne crée pas d’effet blanc sous le flash mais un rendu photogénique, avec la technologie photochromique, qui diffuse et s’adapte à de nouvelles sources de lumière : la peau est impeccable aussi bien en photo qu’en vrai. N’estompez jamais votre lumière."])},
      "url": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.be/fr/poudre-compacte-fixante-light-reflecting/999NAC0000099.html"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ACHETER"])},
      "image-1": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-1.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-1.jpg"])}
        }
      },
      "image-2": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-2.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-2.jpg"])}
        }
      },
      "image-3": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-3.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-3.jpg"])}
        }
      },
      "image-4": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-4.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-4.jpg"])}
        }
      },
      "image-5": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-5.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-5.jpg"])}
        }
      }
    },
    "slice-2": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blush"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Our cult-favorite cheek color, now available in an upgraded formula, pops, sculpts, and highlights for up to 16 hours of silky, weightless wear."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pure Pigment Blend achieves true-color payoff with an innovative combination of four blendable pigments that make an impact while helping to blur the look of imperfections."])},
      "url": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.be/fr/blush/999NAC0000192.html"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EN VOIR PLUS"])},
      "image-1": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-1.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-1.jpg"])}
        }
      },
      "image-2": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-2.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-2.jpg"])}
        }
      },
      "image-3": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-3.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-3.jpg"])}
        }
      },
      "image-4": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-4.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-4.jpg"])}
        }
      }
    },
    "slice-3": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EXPLICIT LIPSTICK"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Découvrez la nouvelle icône du luxe durable."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un raisin haute précision rechargeable glisse sur les lèvres pour les sculpter avec sophistication, tandis que notre complexe Luxe Comfort à base d’Huile de graine d’Églantier et d’Acide hyaluronique offre aux lèvres une couvrance onctueuse et légère, moyenne à totale. La couleur classique prend un caractère inattendu : elle fait briller et provoque pour une élégance intense—teintée d’audace."])},
      "url": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.be/fr/explicit-lipstick/999NAC0000221.html"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ACHETER"])},
      "image-1": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-1.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-1.jpg"])}
        }
      },
      "image-2": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-2.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-2.jpg"])}
        }
      },
      "image-3": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-3.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-3.jpg"])}
        }
      },
      "image-4": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-4.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-4.jpg"])}
        }
      }
    },
    "slice-4": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["LIGHT REFLECTING<sup>TM</sup> FOUNDATION"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Souvent imitée mais jamais égalée, notre formule primée est la numéro un incontournable de la luminosité."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ce fond de teint-soin floute instantanément les imperfections et lisse le grain de peau tout en améliorant la clarté du teint au fil du temps. Couvrance moyenne modulable, texture respirante et longue tenue pour une peau sublimée, jamais masquée."])},
      "url": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.be/fr/explicit-lipstick/999NAC0000221.html"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ACHETER"])},
      "image-1": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-1.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-1.jpg"])}
        }
      },
      "image-2": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-2.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-2.jpg"])}
        }
      },
      "image-3": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-3.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-3.jpg"])}
        }
      },
      "image-4": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-4.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-4.jpg"])}
        }
      }
    },
    "slice-5": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["RADIANT CREAMY CONCEALER"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Convoité par les artistes et les autres, cet incontournable polyvalent est plébiscité pour son utilisation quotidienne sans effort."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une texture ultra-luxueuse formulée avec notre Synergie végétale multi-active qui offre un fini lumineux et aide la peau à maintenir son hydratation vitale pendant 24 heures. Des poudres uniques unifient le teint et floutent l’apparence des imperfections pendant 16 heures dans tous les cas d’usage. Disponible en 30 teintes. Illumine, corrige et sublime."])},
      "url": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.narscosmetics.be/fr/radiant-creamy-concealer/999NACRCC0001.html"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ACHETER"])},
      "image-1": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-1.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-1.jpg"])}
        }
      },
      "image-2": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-2.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-2.jpg"])}
        }
      },
      "image-3": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-3.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-3.jpg"])}
        }
      },
      "image-4": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-4.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-4.jpg"])}
        }
      }
    },
    "next": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_next.jpg"])}
      },
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["IL ÉTAIT UNE FOIS. NARS."])}
    }
  },
  "blocker": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PLEASE ROTATE <br/>YOUR SCREEN"])},
    "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AVAILABLE ONLY IN PORTRAIT MODE"])}
  }
}